module.exports = __webpack_public_path__ + "static/media/saint_louis_team.1836ba4f.jpg";